<template>
  <div class='menu' style="padding:0px 0px 10px 0px" v-if="userInfo.customerGroupId == 1">
    <div class="r childupdowncenter" @click="toUrl('/user/')">
      <img src="/images/icon_user_b.png" style="padding:0px;" />{{t("menu.personal")}}
    </div>
    <div class="userline"></div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=1')">
      <img src="/images/user/wishlist.png" style="padding:0px;" />{{t("menu.Wishlist")}}
    </div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=2')">
      <img src="/images/user/booking.png" style="padding:0px;" />{{t("menu.mybookings")}}
    </div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=43')">
      <img src="/images/user/booking.png" style="padding:0px;" />{{t("menu.myVouchers")}}
    </div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=3')">
      <img src="/images/user/Wallet.png" style="padding:0px;" />{{t("menu.mywallet")}}
    </div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=4')">
      <img src="/images/mine/inquiry.png" style="padding:0px;" />{{t("menu.myinquiry")}}
    </div>
    <div class="userline"></div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=5')">
      <img src="/images/mine/Stories.png" style="padding:0px;" />{{t("menu.mystory")}}
    </div>
    <div v-if="shareJourneyEnabled" class="r childupdowncenter" @click="toUrl('/user/?active=10')">
      <img src="/images/mine/Stories.png" style="padding:0px;" />{{t("menu.shareJourney")}}
    </div>

    <div class="userline"></div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=6')">
      <img src="/images/user/network.png" style="padding:0px;" />{{t("menu.network")}}
    </div>

    <div v-if="userInfo.customerGroupId * 1 == 1" class="r childupdowncenter" @click="toUrl('/user/?active=7')">
      <img src="/images/mine/Membership.png" style="padding:0px;" />{{t("menu.membership")}}
    </div>

    <div v-if="affiliateEnabled" class="r childupdowncenter" @click="toUrl('/user/?active=41')">
      <img class="affiliate-icon" src="/images/user/affiliate.svg" style="padding:0px;" />{{t("menu.cashback")}}
    </div>

    <div class="userline"></div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=8')">
      <img src="/images/user/newsletter.png" style="padding:0px;" />{{t("menu.newsletter")}}
    </div>
    <div class="userline" v-if="!isBooking"></div>
    <div v-if="!isBooking" class="r childupdowncenter" @click="logOut()"><img src="/images/user/Logout.png"
        style="padding:0px;" />{{t("common.logout")}}
    </div>
  </div>
  <div class='menu' style="padding:0px 0px 10px 0px" v-else-if="userInfo.customerGroupId == 3||userInfo.customerGroupId == 4">
    <div class="r childupdowncenter" @click="toUrl('/user/')">
      <img src="/images/icon_user_b.png" style="padding:0px;" />{{t("menu.personal")}}
    </div>
    <div class="userline"></div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=1')">
      <img src="/images/user/wishlist.png" style="padding:0px;" />{{t("menu.Wishlist")}}
    </div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=2')">
      <img src="/images/user/booking.png" style="padding:0px;" />{{t("menu.mybookings")}}
    </div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=3')">
      <img src="/images/user/Wallet.png" style="padding:0px;" />{{t("menu.mywallet")}}
    </div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=31')">
      <img src="/images/mine/diamond.png" style="padding:0px;" />{{t("menu.partner")}}
    </div>

    <div class="r childupdowncenter" @click="toUrl('/user/?active=32')">
      <img src="/images/mine/commission.png" style="padding:0px;" />{{t("menu.commission")}}
    </div>

    <div class="r childupdowncenter" @click="toUrl('/user/?active=33')">
      <img src="/images/mine/promotion.png" style="padding:0px;" />{{t("menu.promotion")}}
    </div>
    <!--   
    <div class="r childupdowncenter" @click="toUrl('/user/?active=34')">
      <img src="/images/mine/marketing.png" style="padding:0px;" />Marketing Material
    </div> -->

    <!-- 
    { icon: '/images/mine/diamond', text: 'Partner Vintage Program', key:3,href: '', active: false },
        { icon: '/images/mine/commission', text: 'Commission', key:4,href: '', active: false },
        { icon: '/images/mine/promotion', text: 'Promotion', key:5,href: '', active: false },
        { icon: '/images/mine/marketing', text: 'Marketing Material', key:6,href: '', active: false }, -->
    <div class="userline"></div>
    <div class="r childupdowncenter" @click="toUrl('/user/?active=8')">
      <img src="/images/user/newsletter.png" style="padding:0px;" />{{t("menu.newsletter")}}
    </div>
    <div class="userline" v-if="!isBooking"></div>
    <div v-if="!isBooking" class="r childupdowncenter" @click="logOut()"><img src="/images/user/Logout.png"
        style="padding:0px;" />{{t("common.logout")}}
    </div>
  </div>
</template>

<script setup>
//import Request from '@/services/Request';
import { useUserStore } from '@/stores/UserStore';
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { localDriver } from '@/utils/localDriver'
import AffiliateService from '@/services/AffiliateService'
import TravelExplorerService from '@/services/TravelExplorerService'
const { t } = useI18n();

const emit = defineEmits(['setLogout']);
const isBooking = ref(false);
const affiliateEnabled = ref(false);
const shareJourneyEnabled = ref(false);
const userStore = useUserStore()
const userInfo = userStore.user;
onMounted(() => {
  const pathname = window.location.pathname.replace(/\/$/, '')
  isBooking.value = [
    '/booking',
    '/flight',
    '/booking/insurance',
    '/payment',
    '/user/flight',
    '/user/insurance',
    '/user/payment'
  ].includes(pathname)
  AffiliateService.getModuleStatus()
    .then((res) => {
      affiliateEnabled.value = !!res?.success && !!res?.data?.enabled
    })
    .catch(() => {
      affiliateEnabled.value = false
    })
  TravelExplorerService.getShareJourneyStatus()
    .then((res) => {
      shareJourneyEnabled.value = !!res?.success && !!res?.data?.enabled
    })
    .catch(() => {
      shareJourneyEnabled.value = true
    })
  // console.log(isBooking);

  // console.log("userkemui",userInfo);
});
function toUrl(url) {
  document.location = url
}

async function logOut() {
  await localDriver.removeItem('customer_id');
  await localDriver.removeItem('customerInfo');
  await userStore.logout()
  emit('setLogout')
}
</script>
<style>
.menu div {
  font-size: 1.3rem;
}

.menu .r img {
  width: 17px;
  height: 17px;
  margin-right: 5px;
}

/* affiliate.svg uses width/height 100% with preserveAspectRatio=none; the header's
   `.usermenu img { height: auto !important }` would stretch it, so give it a fixed box. */
.usermenu img.affiliate-icon {
  width: 1rem !important;
  height: 1rem !important;
}

@media screen and (max-width: 750px) {
  .menu div {
    font-size: 1.1rem;
  }
}
</style>
